import { inject, Injectable } from "@angular/core";
import { InitTask } from "./init-task.interface";
import { UpdateService } from "../shared/services/update.service";

/** Файл, в котором мы подключаем сервис/стор обязательный для загрузки перед очисткой splash screen */

@Injectable({ providedIn: 'root' })
export class UpdateInitTask implements InitTask {
    private updateSvc = inject(UpdateService);

    description = 'init.update-check';
    priority = 3;
    async run() {
        this.updateSvc.startUpdateCheck();
    }
}